module.exports = __webpack_public_path__ + "img/tomasovszki_reka.c1cfcd26.jpg";